import { style } from "typestyle"

export const homeworkList_topicListDiv = style({
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem"
})
